import {
  COURT_CASES_V2_ROUTES,
  LEGAL_INTELLIGENCE_ROUTES,
  type LegalIntelSection,
} from '../constants';

import type { LegalSearchBreadcrumbSegment } from './shared/LegalSearchBreadcrumbs';

const SECTION_LABEL: Record<LegalIntelSection, string> = {
  'legal-research': 'Legal Research',
  'class-actions-recalls': 'Class Action & Recalls',
  'intellectual-property': 'Intellectual Property',
};

function sectionFromPathname(pathname: string): LegalIntelSection {
  if (
    pathname.includes('/class-action-lawsuits') ||
    pathname === COURT_CASES_V2_ROUTES.RECALLS ||
    pathname === COURT_CASES_V2_ROUTES.RECALL_REPORT ||
    pathname.startsWith(`${COURT_CASES_V2_ROUTES.RECALL_REPORT}/`)
  ) {
    return 'class-actions-recalls';
  }
  return 'legal-research';
}

export function getCourtCasesV2MainNavBreadcrumbSegments(
  pathname: string,
  _search: string
): LegalSearchBreadcrumbSegment[] {
  const section = sectionFromPathname(pathname);

  return [
    { label: 'Legal Intelligence', to: LEGAL_INTELLIGENCE_ROUTES.BASE },
    { label: SECTION_LABEL[section] },
  ];
}
